import { dom } from '../dom.js';

function handleSignIn() {
  window.location.href = '/auth/google/login';
}

export function renderLandingPage() {
  const landingPageHTML = `
    <div id="landing-page">
      <section class="hero-section">
        <h1>Wakelog</h1>
        <h2>Tell Your Sailing Stories</h2>
        <p>More than just lines on a map. Wakelog turns your GPX tracks and performance stats into a rich narrative of your voyages.</p>
        <button id="signin-btn" class="login-btn button-base google-signin">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48">
            <title>Google G Logo</title>
            <g>
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
              <path fill="none" d="M0 0h48v48H0z"></path>
            </g>
          </svg>
          Sign In with Google
        </button>
      </section>
      <section class="feature-showcase">
        <div class="feature" data-image="feature1.png">
          <h2>Upload Your Data</h2>
          <p>Seamlessly import GPX data from your favorite navigation apps to create detailed tracks of your voyages.</p>
        </div>
        <div class="feature" data-image="feature2.png">
          <h2>Add Your Thoughts</h2>
          <p>Enrich your tracks with personal logs, notes, and photos, transforming raw data into a rich narrative.</p>
        </div>
        <div class="feature" data-image="feature3.png">
          <h2>Share Your Tale</h2>
          <p>Combine individual tracks into cohesive trips and share your sailing adventures with friends and fellow enthusiasts.</p>
        </div>
      </section>
      <section class="visual-context">
        <img src="/trip.png" alt="Wakelog interface screenshot" id="feature-image" />
      </section>
    </div>
  `;

  dom.appContent.innerHTML = landingPageHTML;
  dom.appContent.classList.remove('hidden');
  dom.loginModal.classList.remove('show');
  dom.header.classList.add('hidden');
  dom.tracksPanel.classList.add('hidden');
  dom.mapContainer.classList.add('hidden');
  if (dom.loadingOverlay) dom.loadingOverlay.classList.remove('show');


  const signinBtn = document.getElementById('signin-btn');
  signinBtn.addEventListener('click', handleSignIn);

  const featureBoxes = document.querySelectorAll('.feature');
  const featureImage = document.getElementById('feature-image');

  featureBoxes.forEach(box => {
    box.addEventListener('click', (event) => {
      event.stopPropagation(); // Prevent the document click listener from firing immediately
      featureBoxes.forEach(b => b.classList.remove('active'));
      box.classList.add('active');
      featureImage.src = `/${box.dataset.image}`;
    });
  });

  document.body.addEventListener('click', (event) => {
    // Check if the click target is inside a feature box or the sign-in button
    const isClickInsideFeature = event.target.closest('.feature');
    const isClickInsideSignInButton = event.target.closest('#signin-btn');

    if (!isClickInsideFeature && !isClickInsideSignInButton) {
      featureBoxes.forEach(b => b.classList.remove('active'));
      featureImage.src = '/trip.png';
    }
  });
}
